const noticeReducer = (state = {}, action) => {
    switch (action.type) {
      case "ADD_NOTICE": {
        return{
          ...state,
          addNoticeSuccess: action.success
        }
      }
      case "ADD_NOTICE_ERR": {
        return{
          ...state,
          addNoticeError: action.err
        }
      }
      default:
        return state;
    }
  };
  
  export default noticeReducer;
  